import { mapGetters } from 'vuex';

export default {
  name: 'footer-column',
  props: {
    itemList: {
      type: Array,
      default: () => [],
    },
    path: {
      type: String,
      default: () => '',
    },
    caption: {
      type: String,
      default: null,
    },
    index: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      isRTLPage: 'GET_IS_RLT_PAGE',
    }),
    getItemListWithLimit() {
      return this.itemList.slice(0, this.firstShowingCount + this.row);
    },
  },
  mounted() {
  },
  data() {
    return {
      firstShowingCount: 8,
      row: 0,
      isShowMore: false,
    };
  },
  methods: {
    showMore() {
      this.row += 6;
      this.isShowMore = (this.row + this.firstShowingCount > this.itemList.length - 1);
    },
  },
};
